import { MutationOptions, useMutation } from "@apollo/client";

import { GqlSettingsFormTemplateQuestionCreateInput } from "~/__generated__";

import { SettingsFormTemplateEditor_Shared_AddFormTemplateQuestionDocument } from "../mutations.generated";

export default function useSettingsFormTemplateEditor_Shared_AddFormTemplateQuestion(
    refetchQueries?: MutationOptions["refetchQueries"],
) {
    const [mutate, { loading, error }] = useMutation(
        SettingsFormTemplateEditor_Shared_AddFormTemplateQuestionDocument,
        {
            refetchQueries,
        },
    );

    const createFormTemplateQuestion = async (input: GqlSettingsFormTemplateQuestionCreateInput) => {
        const result = await mutate({
            variables: {
                input,
            },
        });
        return result.data?.settingsFormTemplateQuestionCreate;
    };

    return {
        createFormTemplateQuestion,
        loading,
        error,
    };
}
